/**
 * Removes all non alphanumeric characters from the given string.
 * @example
 * // returns SomeTextWithRedundantCharacters
 * charsOnly('Some Text & With Redundant / Characters.')
 * @returns {String} Alphanumeric string
 */

export const charsOnly = str => {
  if (!str) return ''

  return str
    .toString()
    .replace(/[\W_]+/g, ' ')
    .replace(/ +/g, '')
}

export const convertStringToLink = str => {
  if (!str) return ''

  return str
    .replace(/[\W_]+/g, ' ')
    .toLowerCase()
    .trim()
    .split(' ')
    .join('-')
}
